"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.PlusIcon16Light = forwardRef_1.forwardRef('PlusIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M7.5 1.91a.5.5 0 0 1 .5.5V7h4.59a.5.5 0 0 1 0 1H8v4.59a.5.5 0 0 1-1 0V8H2.41a.5.5 0 1 1 0-1H7V2.41a.5.5 0 0 1 .5-.5Z" })));
});
